import { render } from "./InputEmployees.vue?vue&type=template&id=3efd7554"
import script from "./InputEmployees.vue?vue&type=script&lang=js"
export * from "./InputEmployees.vue?vue&type=script&lang=js"
script.render = render

export default script